module.exports = __webpack_public_path__ + "img/info_cha.e8872475.png";